// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as AddUserComponent} from './AddUser.svg';

import Icon, { TIconProps } from '../Icon';

export const IconAddUser = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <AddUserComponent/>
  </Icon>
));
